import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Loading } from '~/components/Loading';

export type QueryKey = ['getProjects', string];

export const Route = createFileRoute('/_auth/projects')({
  component: RouteComponent,
  pendingComponent: () => <Loading />,
});

function RouteComponent() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate({ to: '/home/integrations' });
  }, [navigate]);

  return null;
}
